/* JYM price per serving — swaps the pre-rendered per-variant line on Impact's `variant:change` event.
   Markup: snippets/jym-price-per-serving.liquid. Decision record: docs/pdp-redesign/PLAN.md */
(function () {
  if (customElements.get('jym-price-per-serving')) return;

  class JymPricePerServing extends HTMLElement {
    connectedCallback() {
      try {
        this.lines = JSON.parse(this.querySelector('[data-lines]').textContent);
      } catch (e) {
        this.lines = {};
      }
      this.render(this.dataset.variantId);
      this.onChange = (event) => {
        const id = event.detail && event.detail.variant && event.detail.variant.id;
        if (id) this.render(String(id));
      };
      // The event bubbles from the product form; listen on document so we are independent of DOM placement.
      document.addEventListener('variant:change', this.onChange);
    }

    disconnectedCallback() {
      document.removeEventListener('variant:change', this.onChange);
    }

    render(id) {
      const target = this.querySelector('[data-line]');
      const html = this.lines[id];
      if (html) {
        target.innerHTML = html;
        this.hidden = false;
      } else {
        target.innerHTML = '';
        this.hidden = true;
      }
    }
  }

  customElements.define('jym-price-per-serving', JymPricePerServing);
})();
